import type { AppThunk } from '@core/core/store'
import type { ProjectId } from 'common/types'

import { getFaultsByProjectIdApi } from '../../api'
import type { FaultInfo } from '../../types'

export const getAndUpdateFaults =
  (
    projectId: ProjectId,
    callback: (faults: Pick<FaultInfo, 'id' | 'domain'>[]) => void,
  ): AppThunk =>
  () => {
    getFaultsByProjectIdApi(projectId).then(res => {
      callback(res.map(({ id, domain }) => ({ id, domain })))
    })
  }
